import userAuth from "../../features/user-auth/user-auth-saga";
import userProfile from "../../features/user-profile/user-profile-saga";
import onBoarding from "../../features/onboarding/onboarding-saga";
import { all } from "redux-saga/effects";

export default function* rootSaga() {
  yield all([userAuth(), onBoarding(), userProfile()]);
}
